import type { AxiosResponse } from 'axios';
import { api } from '@/services/api/main/axios';

export const getBotFiltersApiRequest = async (): Promise<unknown> => {
  const res = await api.get<{ payload: unknown }>('bot-filters');
  return res.data.payload;
};

export const getBotFilterApiRequest = async (id: string): Promise<unknown> => {
  const res = await api.get<{ payload: unknown }>(`bot-filters/${id}`);
  return res.data.payload;
};

export const postCreateBotFilterApiRequest = async (
  payload: object,
): Promise<AxiosResponse<unknown>> => {
  return api.post('bot-filters', payload);
};

export const putUpdateBotFilterApiRequest = async (
  id: string,
  payload: object,
): Promise<AxiosResponse<unknown>> => {
  return api.put(`bot-filters/${id}`, payload);
};

export const deleteBotFilterApiRequest = async (id: string): Promise<AxiosResponse<unknown>> => {
  return api.delete(`bot-filters/${id}`);
};

export const postArchiveBotFiltersApiRequest = async (
  payload: object,
): Promise<AxiosResponse<unknown>> => {
  return api.post('bot-filters/archive', payload);
};

export const postRestoreBotFiltersApiRequest = async (
  payload: object,
): Promise<AxiosResponse<unknown>> => {
  return api.post('bot-filters/restore', payload);
};
